var _path, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgKnowmoreArrow(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_694_1200)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_694_1200",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 22,
    height: 22
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22 0H0V22H22V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_694_1200)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.00104 21.5141C1.85506 21.5135 1.71539 21.455 1.61237 21.3516L0.606311 20.3469C0.535015 20.2564 0.496527 20.1442 0.497327 20.029C0.498126 19.9137 0.538257 19.8021 0.610803 19.7126L17.179 3.14537L5.12565 3.13209C4.99593 3.12902 4.87267 3.075 4.78248 2.9817C4.73788 2.9384 4.70244 2.88629 4.67838 2.82897C4.65432 2.77164 4.6421 2.71028 4.64244 2.64811V1.22662C4.64312 1.10117 4.6933 0.981072 4.7819 0.892249C4.8705 0.803425 4.99043 0.753011 5.11588 0.752014L20.7786 0.753186C20.8418 0.753338 20.9044 0.766234 20.9626 0.791077C21.0207 0.815919 21.0732 0.852131 21.1171 0.897717C21.1616 0.941269 21.1969 0.993406 21.221 1.05084C21.245 1.10828 21.2573 1.16983 21.2571 1.23209V16.8934C21.256 17.0188 21.2059 17.1389 21.1174 17.2278C21.029 17.3167 20.9092 17.3678 20.7838 17.3696L19.3651 17.3719C19.3037 17.3729 19.2429 17.361 19.1862 17.3376C19.1295 17.3141 19.078 17.2796 19.0352 17.2356C18.9924 17.1936 18.9588 17.1431 18.9362 17.0876C18.9136 17.032 18.9028 16.9725 18.9042 16.9126L18.9251 4.77233L2.29635 21.3997C2.25711 21.4372 2.21088 21.4668 2.16022 21.4864C2.10956 21.506 2.05535 21.5154 2.00104 21.5141Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_694_1200"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 22,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKnowmoreArrow);
export default __webpack_public_path__ + "static/media/knowmore_arrow.097e87536adfa912ea4b7a5db7340ac0.svg";
export { ForwardRef as ReactComponent };